import { useContext, useEffect, useState } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const BankDetails = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, bankDetails: false}))
		startHere.set((p) => ({ ...p, show: true}))
	}
	
	const steps = [
		{
			target: '.bankDetailsFirstStep',
			title: "Fill-in Main Bank Details",
			content: 'Fill-in your company main bank details.',
			disableBeacon: true,
			placement: "right",
		},
		{
			target: '.bankDetailsSecondStep',
			title: "Read Terms",
			content: 'Read and understand carefully the terms and conditions.',
			disableBeacon: true,
			placement: "right",
		},
		{
			target: '.bankDetailsThirdStep',
			title: "Read Later",
			content: 'Click to remind you again.',
			disableBeacon: true,
			placement: "right",
		},
		{
			target: '.bankDetailsFourthStep',
			title: "Save and Submit",
			content: 'Click to save and submit your bank details.',
			disableBeacon: true,
			placement: "right",
		},
	]
	
	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.bankDetailsFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 200);
		return () => clearInterval(interval);
	}, []);

	return (
		firstStepReady && 
		<JoyrideWrapper  
			run={Boolean(walkthrough.data.bankDetails)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="bankDetails" 
			featureName="setup"
		/>
	);
}
